<div class="detail-container">
    <!-- Back Nav -->
    <div class="nav-header">
        <button class="back-btn" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon> Volver al listado
        </button>
    </div>

    <div *ngIf="isLoading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando detalle...</p>
    </div>

    <div *ngIf="hasError && !isLoading" class="error-state">
        <p>{{ errorMessage }}</p>
        <button (click)="goBack()">Volver</button>
    </div>

    <!-- Main Detail Card -->
    <div class="detail-card" *ngIf="!isLoading && booking">
        <!-- Card Header (Blue Gradient) -->
        <div class="card-header">
            <div class="route-info">
                <h2>
                    <mat-icon>inventory_2</mat-icon> Reserva
                    {{ formatBookingId(booking.id) }}
                </h2>
                <p>
                    {{ booking.clientName || '-' }} •
                    {{ booking.status || '-' }}
                </p>
            </div>
            <div class="header-actions">
                <button (click)="downloadPdf()" [disabled]="isDownloadingPdf">
                    <ng-container *ngIf="!isDownloadingPdf">
                        <mat-icon>download</mat-icon> PDF
                    </ng-container>
                    <ng-container *ngIf="isDownloadingPdf">
                        <mat-spinner
                            diameter="18"
                            class="inline-spinner"
                        ></mat-spinner>
                        Generando...
                    </ng-container>
                </button>
            </div>
        </div>

        <!-- Card Body -->
        <div class="card-body">
            <!-- Section: Información General -->
            <div class="detail-section">
                <h3><mat-icon>description</mat-icon> Información General</h3>
                <div class="info-grid">
                    <div class="info-item">
                        <label>Tipo Servicio Logístico</label>
                        <span>{{ booking.logisticService || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Tipo Reserva</label>
                        <span>{{ booking.bookingType || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Tipo Embarque</label>
                        <span>{{ booking.shipmentType || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>S / Conv</label>
                        <span>{{ booking.shipConvenience || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Naviera</label>
                        <span>{{ booking.carrierName || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Nave-Viaje</label>
                        <span>{{ booking.vesselName || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Cliente</label>
                        <span>{{ booking.clientName || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Exportador</label>
                        <span>{{ booking.exporterName || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Consignatario</label>
                        <span>{{ booking.consignee || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Depósito</label>
                        <span>{{ booking.depot || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Emisión B/L</label>
                        <span>{{ booking.blType || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Término Pago</label>
                        <span>{{ booking.paymentTerm || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Contrato Naviera</label>
                        <span>{{ booking.carrierContract || '-' }}</span>
                    </div>
                </div>
            </div>

            <!-- Section: Fechas Límite -->
            <div class="detail-section">
                <h3><mat-icon>schedule</mat-icon> Fechas Límite del Viaje</h3>
                <div class="deadlines-box">
                    <div class="deadlines-content">
                        <div class="deadline-item">
                            <label>Stacking</label>
                            <span>{{ booking.stackingRemarks || '-' }}</span>
                        </div>
                        <div class="deadline-item">
                            <label>Corte Documental</label>
                            <span class="date-highlight">{{
                                formatDate(booking.documentalCutOff)
                            }}</span>
                        </div>
                        <div class="deadline-item">
                            <label>Late Arrival</label>
                            <span>{{ booking.lateArrivalRemarks || '-' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Section: Transporte / Ruta -->
            <div class="detail-section">
                <h3><mat-icon>directions_boat</mat-icon> Transporte</h3>
                <div class="info-grid">
                    <div class="info-item">
                        <label>Puerto Embarque (POL)</label>
                        <span>{{ booking.polName || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>ETD Estimado</label>
                        <span>{{
                            formatDate(booking.etd || booking.bookingDate)
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>Puerto Descarga (POD)</label>
                        <span>{{ booking.podName || '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>ETA Estimado</label>
                        <span>{{ formatDate(booking.eta) }}</span>
                    </div>
                    <div class="info-item">
                        <label>Viaje OPB</label>
                        <span class="highlight">{{
                            formatVoyageId(booking.voyageId)
                        }}</span>
                    </div>
                </div>
            </div>

            <!-- Section: Liner / Contenedores -->
            <div
                class="detail-section"
                *ngIf="booking.containers && booking.containers.length > 0"
            >
                <h3><mat-icon>inventory_2</mat-icon> Liner / Contenedores</h3>

                <!-- Container Specs -->
                <div class="info-grid">
                    <div class="info-item">
                        <label>Especie</label>
                        <span>{{
                            booking.containers[0].packages &&
                            booking.containers[0].packages.length > 0
                                ? booking.containers[0].packages[0].merchandise
                                : '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>Código HS</label>
                        <span>{{
                            booking.containers[0].packages &&
                            booking.containers[0].packages.length > 0
                                ? booking.containers[0].packages[0].hsCode
                                : '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>Tipo Contenedor</label>
                        <span>{{
                            booking.containers[0].containerType || '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>% Humedad</label>
                        <span>{{ booking.containers[0].humidity ?? '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>Temperatura</label>
                        <span>{{
                            booking.containers[0].temperature ?? '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>Un. Temp</label>
                        <span>{{
                            booking.containers[0].temperatureUnit || '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>Ventilación</label>
                        <span>{{
                            booking.containers[0].ventilation ?? '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>Un. Vent.</label>
                        <span>{{
                            booking.containers[0].ventilationUnit || '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>Tratamiento Frío</label>
                        <span>{{
                            booking.containers[0].coldTreatment || '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>Atmósfera</label>
                        <span>{{
                            booking.containers[0].controlledAtmosphere || '-'
                        }}</span>
                    </div>
                    <div class="info-item">
                        <label>O2</label>
                        <span>{{ booking.containers[0].o2 ?? '-' }}</span>
                    </div>
                    <div class="info-item">
                        <label>CO2</label>
                        <span>{{ booking.containers[0].co2 ?? '-' }}</span>
                    </div>
                </div>

                <!-- Containers Table -->
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Nro. Reserva</th>
                                <th>Nro. B/L</th>
                                <th>Nro. Contenedor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let item of booking.containers;
                                    let i = index
                                "
                            >
                                <td class="font-bold">{{ i + 1 }}</td>
                                <td class="font-mono">
                                    {{ item.carrierBookingNumber || '-' }}
                                </td>
                                <td class="font-mono">
                                    {{ item.masterBl || '-' }}
                                </td>
                                <td class="font-mono font-bold">
                                    {{ item.containerNumber || '-' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Observaciones -->
            <div class="detail-section" *ngIf="booking.remarks">
                <h3><mat-icon>notes</mat-icon> Observaciones</h3>
                <div class="observations-box">
                    <p>{{ booking.remarks }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
